import React from 'react';
export function CTABanner() {
  return <section id="quote" className="relative py-24 bg-brand overflow-hidden" data-id="element-1">
      {/* Grass background image */}
      <div className="absolute inset-0 bg-cover bg-center" style={{
      backgroundImage: 'url("https://cdn.magicpatterns.com/uploads/kcXS5Zh1e9U3PggMPAm1Sa/se-tsuchiya-1wAmm_d2TDM-unsplash.jpg")'
    }} aria-hidden="true" data-id="element-2" />
      {/* Green color overlay for legibility */}
      <div className="absolute inset-0 bg-brand/90" aria-hidden="true" data-id="element-3" />

      <div className="container relative z-10 mx-auto px-6 max-w-4xl text-center" data-id="element-4">
        <h2 className="font-heading font-bold text-3xl md:text-5xl text-white mb-6 [text-shadow:0_2px_8px_rgba(0,0,0,0.45)]" data-id="element-5">
          Ready to Love Your Yard Again?
        </h2>
        <p className="text-white text-lg md:text-xl mb-10 max-w-2xl mx-auto [text-shadow:0_1px_4px_rgba(0,0,0,0.4)]" data-id="element-6">
          Get your free estimate today. No pressure, no obligation.
        </p>

        <a href="tel:555-0123" className="inline-flex items-center justify-center bg-white text-brand hover:bg-gray-50 font-bold py-4 px-10 rounded-xl transition-colors min-h-[48px] text-lg w-full sm:w-auto shadow-lg hover:shadow-xl transform hover:-translate-y-0.5 duration-200 mb-8" data-id="element-7">
          Get My Free Quote
        </a>

        <div className="text-white text-sm md:text-base [text-shadow:0_1px_3px_rgba(0,0,0,0.4)]" data-id="element-8">
          <p className="font-medium mb-1" data-id="element-9">Call us at (555) 123-4567</p>
          <p data-id="element-10">
            We serve Denton, Argyle, Corinth, Flower Mound, and surrounding
            areas.
          </p>
        </div>
      </div>
    </section>;
}